// extracted by mini-css-extract-plugin
export default {"selected":"Tos_selected__iksHe","tos__body":"Tos_tos__body__i4-5n","tos__content":"Tos_tos__content__q7K-d"};